import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  field: {
    display: 'flex',
    flexDirection: 'column'
  },
  fieldLabel: {
    marginBottom: theme.spacing(1)
  },
  editRow: {
    alignItems: 'flex-start'
  },
  // Fixed, compact width so the fullWidth select sits inline with the save/cancel icons
  // instead of stretching the row and pushing them onto the next line.
  selectWrap: {
    width: 96,
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center'
  },
  reasonWrap: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  iconButton: {
    flex: '0 0 auto',
    padding: theme.spacing(1)
  },
  icon: {
    width: 18,
    height: 18
  },
  // The "Overridden by … : reason" provenance line under the value.
  note: {
    marginTop: theme.spacing(1),
    color: theme.colors?.text_secondary,
    textAlign: 'right'
  }
}));

export default useStyles;
